import { MotorStepService } from './../../../Services/MotorStepService';
import { Router } from '@angular/router';
import { MotorProposal } from './../../../Models/MotorProposal';
import { Component, OnDestroy, DoCheck, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { restURL } from '../../../Models/restURL';
import { Subscription } from 'rxjs';
import { motorProposalService } from '../../../Services/motorProposalService';
import { BindMdl } from '../../../Models/BindMdl';
import { LanguageService } from '../../../Services/languageService';
import { KeyValueChanges, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import Swal from 'sweetalert2';


declare let $: any;
import * as moment from 'moment';
import 'moment-hijri'
import { MotorVehMdl } from '../../../Models/MotorVehMdl';


@Component({
  selector: 'InsuredBasicInfo',
  templateUrl: './InsuredBasicInfo.html',
  styleUrls: ['./InsuredBasicInfo.css']
})
export class InsuredBasicInfo implements OnDestroy, DoCheck, AfterViewInit {

  public prObj: MotorProposal = new MotorProposal();
  public bindObj: BindMdl = new BindMdl();
  public ImageURL: restURL = new restURL();
  public BindMdlObj: MotorVehMdl = new MotorVehMdl();
  public subscription: Subscription;
  public LngSubscription: Subscription;
  public bindSubscription: Subscription;
  public isSubmitted: boolean = false;
  public Lng: string;
  public isError: boolean;
  private ProposalDiffer: KeyValueDiffer<string, any>;
  public disableAddDrivers: boolean;
  public MinSum: boolean;
  public DeducTooltip: string;
  public minDate: Date = new Date();
  public maxDate: Date = new Date();
  public policyToDate: string;

  constructor(private router: Router, private http: HttpClient, private url: restURL, private proposalService: motorProposalService, private lngService: LanguageService, private differs: KeyValueDiffers, private trackingObj: MotorproposalTrackingService, private stepServiceObj: MotorStepService) {
    moment.locale("en-US");
    this.BindMdlObj.MakeImageUrl = this.ImageURL.MakeImagebaseURL;
    this.DeducTooltip = "Deductible is the agreed amount that must be paid by the Insured person making a claim against an insurance policy before an Insurer will pay any compensation.";
    this.stepServiceObj.setStepNum(2);
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng;
      if (this.Lng == "ar") {
        this.DeducTooltip = "قيمة التحمل هو المبلغ المتفق عليه الذي يدفعه المؤمن له عن كل حادث مغطى قبل ان يقوم المؤمن بدفع التعويض اللازم";
      } else {
        this.DeducTooltip = "Deductible is the agreed amount that must be paid by the Insured person making a claim against an insurance policy before an Insurer will pay any compensation.";
      }
    });
    this.ProposalDiffer = this.differs.find(this.prObj).create();
    this.isError = false;
    this.disableAddDrivers = false;
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
      if (this.Lng == "ar") {
        this.DeducTooltip = "قيمة التحمل هو المبلغ المتفق عليه الذي يدفعه المؤمن له عن كل حادث مغطى قبل ان يقوم المؤمن بدفع التعويض اللازم";
      } else {
        this.DeducTooltip = "Deductible is the agreed amount that must be paid by the Insured person making a claim against an insurance policy before an Insurer will pay any compensation.";
      }
    }
    else {
      this.Lng = "en";
      this.DeducTooltip = "Deductible is the agreed amount that must be paid by the Insured person making a claim against an insurance policy before an Insurer will pay any compensation.";
    }
    if (sessionStorage.getItem("mp") === null) {

      this.subscription = this.proposalService.getProposal().subscribe(message => {
        this.prObj = message;
        // if (this.prObj.MinSumInsured < 5000) {
        //   this.prObj.MinSumInsured = 5000;
        // }
        if (this.prObj.MinSumInsured <= 25000) {
          this.prObj.MinSumInsured = 25000;
        }
        if (this.prObj.MaxSumInsured >= 500000 || this.prObj.MaxSumInsured <= 25000) {
          this.prObj.MaxSumInsured = 500000;
        }

        if (this.prObj.addressObj.Insured_StreetName == null || 0) {
          this.prObj.addressObj.Insured_StreetName = '';
          this.prObj.addressObj.streetNameExists = false;
        }
        // this.minDate.setDate(new Date().getDate() + 1);
        // this.maxDate.setDate(new Date().getDate() + Number(this.prObj.MaxEffectiveDateGracePeriod));
        this.minDate.setDate(new Date().getDate() + 1);
        this.minDate = new Date(this.GetDate(this.minDate, "from"));
        this.maxDate.setDate(new Date().getDate() + Number(this.prObj.MaxEffectiveDateGracePeriod));
        //this.policyToDate = this.prObj.ProposalEffTo.toString().split("T")[0];
        this.policyToDate = this.GetDate(this.prObj.ProposalEffTo, "STR");

      });
      this.bindSubscription = this.proposalService.getBindInfo().subscribe(message => { this.bindObj = message; });

      this.checkButtonEnable();
    }
    else {
      this.bindObj = this.proposalService.getBindObj();
      this.prObj = this.proposalService.getProposalObj();
      this.checkButtonEnable();
      if (sessionStorage.getItem("NoDriver") == "Y") {
        this.addInsuredAsMainDriver(event);
      }
      sessionStorage.setItem("NoDriver", "N");
      this.minDate.setDate(new Date().getDate() + 1);
      this.minDate = new Date(this.GetDate(this.minDate, "from"));
      this.maxDate.setDate(new Date().getDate() + Number(this.prObj.MaxEffectiveDateGracePeriod));
      this.policyToDate = this.GetDate(this.prObj.ProposalEffTo, "STR");

    }
  }
  getHijri(hijriDate) {
  }
  ngAfterViewInit() {
    $(document).ready(function () {

      $('[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'hover'
      });
    });
  }

  checkButtonEnable() {
    if (this.prObj.st.StatusCode == "S") {
      this.isError = false;
    }
    else {
      this.isError = true;
    }
  }


  ngDoCheck(): void {
    const changes = this.ProposalDiffer.diff(this.prObj);
    if (changes) {
      this.proposalService.saveProposalObj(this.prObj);
      this.proposalService.saveBindObj(this.bindObj);
    }
  }
  ngOnDestroy() {
    this.LngSubscription.unsubscribe();
  }


  GoNext(valid) {
    if (this.prObj.ProposalEffFrom > this.maxDate || this.prObj.ProposalEffFrom < this.minDate) {
      this.Lng == "en" ? Swal("Invalid Policy Effective Date or Policy Expiry Date") : Swal("تاريخ بدابة سريان الوثيقة أو انتهاء الوثيقة غير صحيح");
      return;
    }
    if (this.prObj.addressObj.CityExists) {
      if (this.prObj.addressObj.Insured_City != this.prObj.insuredDriverObj.DriverCity) {
        this.prObj.addressObj.Insured_City = this.prObj.insuredDriverObj.DriverCity;
        this.cityChange(this.prObj.insuredDriverObj.DriverCity)
      }
    }
    if (this.prObj.Gender != this.prObj.insuredDriverObj.Drivergender) {
      this.prObj.Gender = this.prObj.insuredDriverObj.Drivergender;
    }

    if (this.prObj.isInsuredMainDriver == false && this.prObj.isDriverRequired == false) {
      this.Lng == "ar" ? alert("الرجاء اضافة سائق واحد للمتابعة ") : alert("You Have to add atleast one driver to proceed");
      return;
    }

    this.isSubmitted = true;


    let Insuredindex = this.prObj.driverListObj.findIndex(t => t.DriverLicenseNo == this.prObj.Insured_IDNo);

    if (Insuredindex >= 0) {
      this.prObj.driverListObj[Insuredindex].DriverProfession = this.prObj.InsuredProfessin;
      this.prObj.driverListObj[Insuredindex].DriverEducation = this.prObj.InsuredEducation;
      this.prObj.driverListObj[Insuredindex].NumberOfYearsEachCountry = this.prObj.insuredDriverObj.NumberOfYearsEachCountry;
      this.prObj.driverListObj[Insuredindex].OtherCountriesLicenceHeld = this.prObj.insuredDriverObj.OtherCountriesLicenceHeld;
      this.prObj.driverListObj[Insuredindex].SaudiLicenceHeld = this.prObj.insuredDriverObj.SaudiLicenceHeld;
      this.prObj.driverListObj[Insuredindex].DriverChildrenYears = this.prObj.ChildrenUnder;
      this.prObj.driverListObj[Insuredindex].RoadConvictions = this.prObj.insuredDriverObj.RoadConvictions;
      this.prObj.driverListObj[Insuredindex].ResidenceBuildingNumber = Number(this.prObj.addressObj.Insured_BuildingNo == undefined ? 0 : this.prObj.addressObj.Insured_BuildingNo);
      this.prObj.driverListObj[Insuredindex].ResidenceCity = Number(this.prObj.addressObj.Insured_City == undefined ? 0 : this.prObj.addressObj.Insured_City);
      this.prObj.driverListObj[Insuredindex].ResidenceDistrict = this.prObj.addressObj.Insured_DistName == undefined ? "" : this.prObj.addressObj.Insured_DistName;
      this.prObj.driverListObj[Insuredindex].ResidenceStreet = this.prObj.addressObj.Insured_StreetName == undefined ? "" : this.prObj.addressObj.Insured_StreetName;
      this.prObj.driverListObj[Insuredindex].ResidenceAdditionalNumber = Number(this.prObj.addressObj.Insured_AdditionalCode == undefined ? 0 : this.prObj.addressObj.Insured_AdditionalCode);
      this.prObj.driverListObj[Insuredindex].ResidenceZipCode = Number(this.prObj.addressObj.Insured_PostalCode == undefined ? 0 : this.prObj.addressObj.Insured_PostalCode);
      this.prObj.driverListObj[Insuredindex].ResidenceZone = this.prObj.addressObj.Insured_AreaName == undefined ? "" : this.prObj.addressObj.Insured_AreaName;
      this.prObj.driverListObj[Insuredindex].ResidenceUnitNumber = Number(this.prObj.addressObj.Insured_UnitNo == undefined ? 0 : this.prObj.addressObj.Insured_UnitNo);

      this.prObj.driverListObj[Insuredindex].OfficeBuildingNumber = Number(this.prObj.addressObj.OfficeBuildingNo == undefined ? "" : this.prObj.addressObj.OfficeBuildingNo);
      this.prObj.driverListObj[Insuredindex].OfficeCity = Number(this.prObj.addressObj.OfficeCity == undefined ? "" : this.prObj.addressObj.OfficeCity);
      this.prObj.driverListObj[Insuredindex].OfficeDistrict = this.prObj.addressObj.OfficeDistrict == undefined ? "" : this.prObj.addressObj.OfficeDistrict;
      this.prObj.driverListObj[Insuredindex].OfficeStreet = this.prObj.addressObj.OfficeStreet == undefined ? "" : this.prObj.addressObj.OfficeStreet;
      this.prObj.driverListObj[Insuredindex].OfficeUnitNumber = Number(this.prObj.addressObj.OfficeUnitNo == undefined ? "" : this.prObj.addressObj.OfficeUnitNo);
      this.prObj.driverListObj[Insuredindex].OfficeAdditionalNumber = Number(this.prObj.addressObj.OfficeAdditionalCode == undefined ? 0 : this.prObj.addressObj.OfficeAdditionalCode);
      this.prObj.driverListObj[Insuredindex].OfficeZipCode = Number(this.prObj.addressObj.OfficePostalCode == undefined ? 0 : this.prObj.addressObj.OfficePostalCode);
      this.prObj.driverListObj[Insuredindex].OfficeZone = this.prObj.addressObj.OfficeZone == undefined ? "" : this.prObj.addressObj.OfficeZone;
      this.prObj.driverListObj[Insuredindex].DriverMedicalConditions = this.prObj.insuredDriverObj.DriverMedicalConditions;

    }


    if (this.prObj.isInsuredMainDriver && this.prObj.LicenceExpiryDateExists == false) {
      let insured = this.prObj.driverListObj.find(t => t.DriverLicenseNo == this.prObj.Insured_IDNo)
      if (insured) {
        insured.DriverLic_ExpiryDate = this.prObj.LicenceExpiryDateH;
      }
    }


    if (this.prObj.isInsuredMainDriver) {
      let insured = this.prObj.driverListObj.find(t => t.DriverLicenseNo == this.prObj.Insured_IDNo)
      insured.DriverMaritalStatus = this.prObj.Ins_MaritalStatus;
      insured.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.Ins_MaritalStatus)[0].MarstatusDesc_En;
      insured.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.Ins_MaritalStatus)[0].MarstatusDesc_Ar;
    }
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    if (valid && (this.prObj.st.StatusCode != "F")) {
      if (this.prObj.isEditProposal == false) {
        this.prObj.trackingObj.ScreenNo = "I";
        this.trackingObj.saveTrackStatus(this.prObj)
      }
      sessionStorage.setItem("mp", "Y");
      if (this.prObj.isDriverRequired == true || this.prObj.isDriverMandatory == true) {

        sessionStorage.setItem("CurrentRoute", "DriverInfo");
        this.router.navigate(['NewDashboard/MotorProposalForm/DriverInfo']);
      }
      else {
        sessionStorage.setItem("CurrentRoute", "PremiumInfo");
        this.router.navigate(['NewDashboard/MotorProposalForm/PremiumInfo']);
      }
    }
  }

  onSelectionChange(evt: any) {
    if (evt.target.value == "Yes") {
      this.prObj.isDriverRequired = true;

    }
    else {
      this.prObj.isDriverRequired = false;
    }
  }

  oncommercialSelectionChange(evt: any) {
  }
  cityChange(val) {
    this.prObj.addressObj.Insured_RegionCode = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionCode;
    this.prObj.addressObj.Insured_RegionName = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
    this.prObj.addressObj.Insured_RegionName_Ar = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionNameAr;
    this.prObj.addressObj.Insured_WCity = val;
    this.prObj.addressObj.Insured_POCity = val;
    this.prObj.addressObj.Insured_AreaName = this.prObj.addressObj.Insured_RegionName;
    this.prObj.addressObj.Insured_WAreaName = this.prObj.addressObj.Insured_RegionName;

  }
  OfficecityChange(val) {
    this.prObj.addressObj.OfficeRegionCode = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionCode;
    this.prObj.addressObj.OfficeZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }
  chkRes(val) {
  }
  checkDrivers(val) {
    if (val == false && this.prObj.isInsuredMainDriver == false) {
      this.prObj.isInsuredMainDriver = true;
      this.CheckMainDriver(null, this.prObj.isInsuredMainDriver);
    }
  }
  getVehileUsage(val) {
    this.prObj.vehcileObj.UseOfVehcileEn = this.bindObj.VehcielUsageList.filter(t => t.VehUsagecode == val)[0].VehUsage_DescEn;
    this.prObj.vehcileObj.UseOfVehcileAr = this.bindObj.VehcielUsageList.filter(t => t.VehUsagecode == val)[0].Vehusage_DescAr;
    if (val == "1") {
      this.prObj.IsItCommercial = false;
    }
    else {
      this.prObj.IsItCommercial = true;
    }
  }

  CheckMainDriver(event, value) {
    let index: number;
    if (value == false) {
      this.prObj.isDriverRequired = true;
      this.disableAddDrivers = true;
      index = this.prObj.driverListObj.findIndex(t => t.DriverLicenseNo == this.prObj.Insured_IDNo);
      if (index >= 0)
        this.prObj.driverListObj.splice(this.prObj.driverListObj.findIndex(t => t.DriverLicenseNo == this.prObj.Insured_IDNo), 1);
    }
    else {
      this.disableAddDrivers = false;
      let mainDriverLiceCount = this.prObj.driverListObj.filter(t => t.DriverLicenseNo == this.prObj.Insured_IDNo).length;
      let mainDriverCount = this.prObj.driverListObj.filter(t => t.Ismaindriver == "1").length;
      if (mainDriverLiceCount > 0) {
        this.Lng == "ar" ? alert("Driver ID Already Existed") : alert("Driver ID Already Existed");
      }
      else {
        if (mainDriverCount == 0) {
          this.addInsuredAsMainDriver(event);
        }
        else {
          this.prObj.isInsuredMainDriver = false;
          this.Lng == "ar" ? alert("لاتستطيع إضافة اكثر من سائق رئيسي واحد") : alert("You can not add more than one main Driver");
          event.stopPropagation();
          event.preventDefault();
        }
      }

    }
  }

  addInsuredAsMainDriver(event) {
    if (this.prObj.isInsuredMainDriver && this.prObj.LicenceExpiryDateExists == false) {
      this.prObj.insuredDriverObj.DriverLic_ExpiryDate = this.prObj.LicenceExpiryDateH;
    }
    if (this.prObj.isInsuredMainDriver) {
      this.prObj.insuredDriverObj.DriverMaritalStatus = this.prObj.Ins_MaritalStatus;
      this.prObj.insuredDriverObj.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.Ins_MaritalStatus)[0].MarstatusDesc_En;
      this.prObj.insuredDriverObj.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.Ins_MaritalStatus)[0].MarstatusDesc_Ar;
    }
    if (this.prObj.driverListObj.length < 3) {
      this.prObj.driverListObj.push(this.prObj.insuredDriverObj);

    }
    else {
      this.prObj.isInsuredMainDriver = false;
      this.Lng == "ar" ? alert("لا يمكنك إضافة أكثر من ثلاثة سائقين ") : alert("You can not add more than three drivers");
      event.stopPropagation();
      event.preventDefault();

    }
  }
  getModelInfo() {
    this.prObj.vehcileObj.VechileModelEn = this.bindObj.ModelMasterList.filter(t => t.MODELDESC == this.prObj.vehcileObj.Vehicle_ModelCode)[0].MODELDESCEn;
    this.prObj.vehcileObj.VechileModelAr = this.bindObj.ModelMasterList.filter(t => t.MODELDESC == this.prObj.vehcileObj.Vehicle_ModelCode)[0].MODELDESCAr;

  }



  GetPolicyExpiry(val) {
    this.prObj.ProposalEffFrom = new Date(this.GetDate(val, "From"));
    // this.prObj.ProposalEffFrom = new Date(this.prObj.ProposalEffFrom.setHours(7,0,0));
    // this.prObj.ProposalEffTo = new Date(this.GetDate(this.prObj.ProposalEffFrom));
    this.prObj.ProposalEffTo = new Date(this.GetDate(this.prObj.ProposalEffFrom, "To"));
    //this.prObj.ProposalEffTo.setDate(this.prObj.ProposalEffTo.getDate() + 60);
    this.policyToDate = this.GetDate(this.prObj.ProposalEffTo, "STR");


  }


  GetDate(val, Val1): string {
    if (Val1 == "To") {
      var d = new Date(val),
        month = '' + (d.getMonth() + 1),
        day = '' + (d.getDate()),
        year = '' + (d.getFullYear() + 1);

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return year + "-" + month + "-" + day;
    }
    else {
      var d = new Date(val),
        month = '' + (d.getMonth() + 1),
        day = '' + (d.getDate()),
        year = '' + (d.getFullYear());

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return year + "-" + month + "-" + day;
    }
  }

  FilterDeductables() {
    // // if (this.prObj.AgencyRepair != "")
    // //   return this.bindObj.deductableList.filter(t => t.AgencyCode == Number(this.prObj.AgencyRepair) && Number(this.prObj.SumInsured) >= t.SumInsuredFrom && Number(this.prObj.SumInsured) <= t.SumInsuredTo)
    // // else
    // //   return this.bindObj.deductableList.filter(t => t.AgencyCode == 0)

    if (this.prObj.AgencyRepair != ""  && this.prObj.SumInsured > 0)
    {
      //return this.bindObj.deductableList.filter(t => t.AgencyCode == Number(this.prObj.AgencyRepair))
      return this.bindObj.deductableList.filter(t => {
        const isAgencyCodeMatch = t.AgencyCode === Number(this.prObj.AgencyRepair) ? Number(this.prObj.AgencyRepair) : t.AgencyCode === -1;
        const isSumInsuredValid = this.prObj.SumInsured >= t.SumInsuredFrom && this.prObj.SumInsured <= t.SumInsuredTo;

        return isAgencyCodeMatch && isSumInsuredValid;
      });    
    }     
    else{
      return this.bindObj.deductableList.filter(t => t.AgencyCode == 0)
    }
  }

  RepairTypeChange() {
    this.prObj.DeductableCode = ""
  }

  VehicleValueChange() {
    this.prObj.DeductableCode = ""
  }

  VehicleDescChange(VehDesc: string) {
    this.prObj.SumInsured = 0;
    this.prObj.MaxSumInsured = this.bindObj.AutoData.filter(t => t.VehicleDesc == VehDesc)[0].MaxSuminsured;
    this.prObj.MinSumInsured = this.bindObj.AutoData.filter(t => t.VehicleDesc == VehDesc)[0].MinSuminsured;

    Swal("Please Enter The Market Value Between " + this.prObj.MinSumInsured + " & " + this.prObj.MaxSumInsured);
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/InsuredBasicInfo/InsuredBasicInfo.ts